import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <p className="text-foreground-500 text-sm mb-2">分类浏览</p>
          <h2 className="text-3xl md:text-5xl font-heading font-black text-foreground-950">
            探索你感兴趣的
            <br />
            漫画类型
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-2xl p-6 md:p-7 cursor-pointer hover:bg-background-200/70 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-background-200 mb-5 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl text-foreground-700 group-hover:text-primary-600 transition-colors w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 mb-2">{cat.name}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-3">{cat.description}</p>
              <span className="text-xs text-foreground-400">{cat.count}部作品</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}